import { ArrowDown } from "lucide-react";
import { useReveal } from "@/hooks/useReveal";
import { useLanguage } from "@/i18n/LanguageContext";

const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_novi-hotel/artifacts/jdex5d95_DSC00051%20ed.jpg";

export default function Hero() {
  const ref = useReveal();
  const { t } = useLanguage();

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden bg-[#FAF9F5]"
    >
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt={t.hero.imageAlt}
          className="w-full h-full object-cover"
          style={{ objectPosition: "center 55%" }}
        />
        <div className="absolute inset-0 hero-tint" />
      </div>

      <div
        ref={ref}
        className="reveal relative z-10 max-w-7xl mx-auto px-6 md:px-12 lg:px-20 min-h-[100svh] flex flex-col justify-center pt-24 pb-16"
      >
        <div className="max-w-2xl">
          <span
            className="overline block mb-8 !text-[#6E5648]"
            data-testid="hero-overline"
          >
            {t.hero.overline}
          </span>
          <h1
            data-testid="hero-title"
            className="font-serif-display text-6xl md:text-8xl lg:text-[110px] font-light leading-[0.92] tracking-tight text-[#1A1C19]"
          >
            Novi <span className="italic text-[#363A33]">Hotel</span>
          </h1>

          <div className="mt-14 md:mt-20 flex flex-col sm:flex-row items-start sm:items-center gap-5">
            <a
              href="#camere"
              data-testid="hero-cta-rooms"
              onClick={(e) => {
                e.preventDefault();
                document
                  .querySelector("#camere")
                  ?.scrollIntoView({ behavior: "smooth" });
              }}
              className="btn-primary"
            >
              {t.hero.ctaRooms}
            </a>
            <a
              href="#contatti"
              data-testid="hero-cta-contact"
              onClick={(e) => {
                e.preventDefault();
                document
                  .querySelector("#contatti")
                  ?.scrollIntoView({ behavior: "smooth" });
              }}
              className="btn-ghost"
            >
              {t.hero.ctaContact}
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 right-6 md:right-12 z-10 flex items-center gap-3 text-[#5C6058]">
        <span className="text-[10px] uppercase tracking-[0.3em]">
          {t.hero.scroll}
        </span>
        <ArrowDown size={16} className="animate-bounce" />
      </div>
    </section>
  );
}
